import Loading from 'components/Loading'
import PageTitle from 'components/PageTitle'
import Button from 'new-components/Button'
import CheckboxInput from 'new-components/CheckboxInput'
import FileInput from 'new-components/FileInput'
import Input from 'new-components/Input'
import { dateMask } from 'utils/formatters'
import { getErrorMessage } from './helpers'
import useDocuments from './hooks/useDocuments'
import * as Styles from './styles'

export default function Documents() {
  const {
    loading,
    identity,
    identityIssueDate,
    proofOfResidence,
    proofOfResidenceIssueDate,
    anvisaAuthorization,
    anvisaAuthorizationIssueDate,
    bondProof,
    bondProofIssueDate,
    isProofOfResidenceInOtherName,
    errors,
    savedFiles,
    changeIsProofOfResidenceInOtherName,
    changeFieldValue,
    handleSaveDocuments
  } = useDocuments()

  return (
    <Styles.DocumentsContainer>
      <Loading loading={loading} />
      <PageTitle>Documentos</PageTitle>

      <h2>
        Inserir <strong>documentos do PACIENTE:</strong>
      </h2>

      <Styles.DocumentsContent>
        <Styles.FileInputsWrapper>
          <Styles.FileWithDateWrapper>
            <FileInput
              label="RG, CPF ou CNH"
              description="O arquivo deve conter a frente e verso do documento com uma descrição maior para testar"
              value={identity?.name ?? savedFiles.identity?.originalName}
              url={savedFiles.identity?.url}
              onChange={(file) => changeFieldValue('identity', file)}
            />
            <Input
              value={identityIssueDate}
              onChange={(event) => changeFieldValue('identityIssueDate', dateMask(event.target.value))}
              errorMessage={getErrorMessage('identityIssueDate', errors)}
              width="100%"
              label="Data de emissão:"
              placeholder="dd/mm/aaaa"
              disabled={!identity && !savedFiles.identity}
              isMinimalist
            />
          </Styles.FileWithDateWrapper>
          <Styles.FileWithDateWrapper>
            <FileInput
              label="Autorização da ANVISA"
              value={anvisaAuthorization?.name ?? savedFiles.anvisaAuthorization?.originalName}
              url={savedFiles.anvisaAuthorization?.url}
              onChange={(file) => changeFieldValue('anvisaAuthorization', file)}
            />
            <Input
              value={anvisaAuthorizationIssueDate}
              onChange={(event) =>
                changeFieldValue('anvisaAuthorizationIssueDate', dateMask(event.target.value, 'monthAndYear'))
              }
              errorMessage={getErrorMessage('anvisaAuthorizationIssueDate', errors)}
              width="100%"
              label="Data de emissão:"
              placeholder="mm/aaaa"
              disabled={!anvisaAuthorization && !savedFiles.anvisaAuthorization}
              isMinimalist
            />
          </Styles.FileWithDateWrapper>
        </Styles.FileInputsWrapper>

        <Styles.FileInputsWrapper>
          <Styles.FileWithDateWrapper>
            <FileInput
              label="Comprovante de residência"
              description="Deve ser no nome do paciente"
              errorMessage={getErrorMessage('proofOfResidence', errors)}
              value={proofOfResidence?.name ?? savedFiles.proofOfResidence?.originalName}
              url={savedFiles.proofOfResidence?.url}
              onChange={(file) => changeFieldValue('proofOfResidence', file)}
            />
            <Input
              value={proofOfResidenceIssueDate}
              onChange={(event) => changeFieldValue('proofOfResidenceIssueDate', dateMask(event.target.value))}
              errorMessage={getErrorMessage('proofOfResidenceIssueDate', errors)}
              width="100%"
              label="Data de emissão:"
              placeholder="dd/mm/aaaa"
              disabled={!proofOfResidence && !savedFiles.proofOfResidence}
              isMinimalist
            />
            <CheckboxInput
              id="proof-of-residence-in-other-name"
              label="O comprovante enviado está em nome de outra pessoa"
              checked={isProofOfResidenceInOtherName}
              onChange={() => changeIsProofOfResidenceInOtherName(!isProofOfResidenceInOtherName)}
              style={{ fontSize: '0.85rem', color: '#777777' }}
            />
          </Styles.FileWithDateWrapper>
          {isProofOfResidenceInOtherName ? (
            <Styles.FileWithDateWrapper>
              <FileInput
                label="Comprovante de vínculo"
                description="Preencha caso o comprovante de endereço não esteja em nome do paciente"
                errorMessage={getErrorMessage('bondProof', errors)}
                value={bondProof?.name ?? savedFiles.bondProof?.originalName}
                url={savedFiles.bondProof?.url}
                onChange={(file) => changeFieldValue('bondProof', file)}
              />
              <Input
                value={bondProofIssueDate}
                onChange={(event) =>
                  changeFieldValue('bondProofIssueDate', dateMask(event.target.value, 'monthAndYear'))
                }
                errorMessage={getErrorMessage('bondProofIssueDate', errors)}
                width="100%"
                label="Data de emissão:"
                placeholder="mm/aaaa"
                disabled={!bondProof && !savedFiles.bondProof}
                isMinimalist
              />
            </Styles.FileWithDateWrapper>
          ) : (
            <Styles.GhostInputs />
          )}
        </Styles.FileInputsWrapper>

        <Button
          onClick={handleSaveDocuments}
          disabled={!identity && !anvisaAuthorization && !proofOfResidence && !bondProof}>
          SALVAR MEUS DOCUMENTOS
        </Button>
      </Styles.DocumentsContent>
    </Styles.DocumentsContainer>
  )
}
